
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { InspectionTime, Listing } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';

@Component
export default class InspectionCard extends Vue {
  @Prop()
  private readonly inspectionTime!: InspectionTime;

  @Prop()
  private readonly listing!: Listing;

  handleClicked() {
    API.Listings.GetOpenHomeICS(this.listing.Id, this.inspectionTime.StartDate, this.inspectionTime.EndDate).then((ics) => {
      const fileParts = [ics.VCalContent];
      const blob = new Blob(fileParts, { type: 'text/calendar' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.style.display = 'none';
      document.body.appendChild(a);

      a.href = url;
      a.download = `${this.listing.Address.MicroAddress}.ics`;
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        a.remove();
      }, 10);
    });
  }

  created() {
    this.initAtcbScript();
  }

  initAtcbScript() {
    const existingScript = document.getElementById('add-to-calendar');

    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'add-to-calendar';
      script.type = 'text/javascript';
      script.src = 'https://cdn.jsdelivr.net/npm/add-to-calendar-button@2';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  getCalendarDate() {
    const sd = new Date(this.inspectionTime.StartDate);
    const ed = new Date(this.inspectionTime.EndDate);

    const padZero = (num: number) => {
      const pad = num < 10 ? `0${num}` : `${num}`;
      return pad;
    };

    const startDate = `${sd.getFullYear()}-${padZero(sd.getMonth() + 1)}-${padZero(sd.getDate())}`;

    const startTime = `${padZero(sd.getHours())}:${padZero(sd.getMinutes())}`;
    const endTime = `${padZero(ed.getHours())}:${padZero(ed.getMinutes())}`;

    return {
      startDate,
      startTime,
      endTime,
    };
  }

  handleAtcbClicked() {
    const myWindow = window as any;
    if (typeof myWindow.atcb_action === 'undefined') return;

    const calendarDate = this.getCalendarDate();
    const config = {
      options: ['Apple', 'Google', 'Outlook.com', 'Yahoo'],
      name: `${Config.Website.Name} - Inspection`,
      description: `Inspection for ${this.listing.Address.MicroAddress} ${this.listing.Address.Suburb}`,
      location: `${this.listing.Address.MicroAddress} ${this.listing.Address.Suburb}`,
      timeZone: 'currentBrowser',
      ...calendarDate,
    };

    myWindow.atcb_action(config);
  }
}
